import { getUiLocale } from './locale';
import { tx } from './pack';

const SYSTEM_FIELD_KEY: Record<string, string> = {
  email: 'contact.field.email',
  last_name: 'contact.field.last_name',
  first_name: 'contact.field.first_name',
  phone_number: 'contact.field.phone_number',
  city: 'contact.field.city',
  state: 'contact.field.state',
  country: 'contact.field.country',
  zip_code: 'contact.field.zip_code',
  first_active: 'contact.field.first_active',
  last_active: 'contact.field.last_active',
  subscribe_status: 'contact.field.subscribe_status',
  hard_bounce_count: 'contact.field.hard_bounce_count',
  soft_bounce_count: 'contact.field.soft_bounce_count',
};

/** 系统预设用户属性展示名。商家自建属性不译。 */
export function contactPropertyLabel(item?: { name?: string; label?: string } | null) {
  const label = item?.label || item?.name || '';
  if (getUiLocale() === 'zh-CN') {
    return label;
  }
  const key = item?.name ? SYSTEM_FIELD_KEY[item.name] : '';
  if (key) {
    return tx(null, key, label);
  }
  return label;
}
